// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__2TkV7","spinner":"Loader_spinner__1u3YE","spin":"Loader_spin__AWQ2h"};